module.exports = __webpack_public_path__ + "static/media/railways.81204432.png";